import { useState } from 'react';
import PropTypes from 'prop-types';
import { toast } from 'sonner';
import { useTranslation } from 'react-i18next';
import Button from 'Components/Atoms/Button/Button';
import TextField from 'Components/Molecules/TextField/TextField';
import SnackbarCard from './SnackbarCard';
import SnackbarClose from './SnackbarClose';
import SnackbarLayout from './SnackbarLayout';
import SnackbarMedia from './SnackbarMedia';
import SnackbarContent from './SnackbarContent';
import SnackbarTitle from './SnackbarTitle';

export default function SnackbarProviderConnectionRequestOtp({ id, icon, message, action, onCancel }) {
    const [otp, setOtp] = useState('');
    const { t } = useTranslation('providers');

    const handleSubmit = (ev) => {
        ev.preventDefault();
        if (!otp) return;

        toast.dismiss(id);
        action?.({ otp });
    };

    const handleCancel = () => {
        toast.dismiss(id);
        onCancel();
    };

    return (
        <SnackbarCard variant="actionRequired">
            <SnackbarClose onClick={() => toast.dismiss(id)} />
            <SnackbarLayout>
                <SnackbarMedia>
                    <img src={icon} alt="" />
                </SnackbarMedia>
                <SnackbarContent as="form" onSubmit={handleSubmit}>
                    <SnackbarTitle className="mb-1">{t('verify-access')}</SnackbarTitle>
                    <div className="flex items-center">
                        <TextField
                            className="grow [&_input]:rounded-r-none! [&_input]:border-r-0! [&_input]:h-[37px]!"
                            value={otp}
                            onChange={(event) => setOtp(event.target.value)}
                        />
                        <Button
                            size="small"
                            variant="primary"
                            type="submit"
                            className="shrink-0 h-[37px] rounded-l-none"
                        >
                            {t('accept')}
                        </Button>
                    </div>
                    <div className="text-gray-500 pt-2 text-xs">{message}</div>
                    {onCancel && (
                        <div className="mt-1 flex justify-end">
                            <Button size="extraSmall" variant="ghost" className="px-0" onClick={handleCancel}>
                                {t('cancel-sync')}
                            </Button>
                        </div>
                    )}
                </SnackbarContent>
            </SnackbarLayout>
        </SnackbarCard>
    );
}

SnackbarProviderConnectionRequestOtp.propTypes = {
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    icon: PropTypes.string.isRequired,
    message: PropTypes.string.isRequired,
    action: PropTypes.func,
    onCancel: PropTypes.func,
};
